(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tb-ui/infobutton-text/assets/javascripts/react/infobutton-text.js') >= 0) return;  svs.modules.push('/components/tb-ui/infobutton-text/assets/javascripts/react/infobutton-text.js');

'use strict';

const _svs$ui = svs.ui,
  Icon = _svs$ui.ReactIcon,
  IconButton = _svs$ui.ReactIconButton;

const ReactInfoButtonText = _ref => {
  let className = _ref.className,
    isInverted = _ref.isInverted,
    text = _ref.text,
    size = _ref.size,
    onClick = _ref.onClick,
    isUnderline = _ref.isUnderline;
  const classNamesLabel = ['pointer u-flex'];
  const classNamesButton = ['info-button-and-text'];
  const color = isInverted ? 'fc-white' : '';
  if (isInverted) {
    classNamesButton.push('f-inverted');
  }
  if (className) {
    classNamesLabel.push(className);
  }
  if (!size) {
    size = '300';
  }
  if (!text || text.length === 0) {
    text = '';
  }
  const underline = isUnderline ? ' u-text-decoration-underline' : '';
  return React.createElement("label", {
    className: classNamesLabel.join(' ')
  }, React.createElement(IconButton, {
    className: classNamesButton.join(' '),
    onClick: onClick
  }, React.createElement(Icon, {
    className: "margin-xs-right",
    color: color,
    icon: "information",
    size: size
  })), text && text.length > 0 && React.createElement("span", {
    className: "".concat(color).concat(underline),
    style: {
      verticalAlign: 'text-top'
    }
  }, text));
};
svs.tb_ui.ReactInfoButtonText = ReactInfoButtonText;

 })(window);